import { RouteRecordRaw } from 'vue-router'

const drillsRoutes: RouteRecordRaw[] = [
  {
    path: '/drills',
    name: 'drills.index',
    component: () => import('@/modules/drills/views/DrillsIndex.vue'),
    meta: {
      pageTitle: 'Drills Index',
      breadcrumbs: ['Drills']
    }
  },
  {
    path: '/drills/:id/show',
    name: 'drills.show',
    component: () => import('@/modules/drills/views/DrillShow.vue'),
    meta: {
      pageTitle: 'Drills',
      breadcrumbs: ['Drills']
    }
  },
  {
    path: '/drills/create',
    name: 'drills.create',
    component: () => import('@/modules/drills/views/DrillEdit.vue'),
    meta: {
      pageTitle: 'Drills',
      breadcrumbs: ['Drills']
    }
  },
  {
    path: '/drills/:id/edit',
    name: 'drills.edit',
    component: () => import('@/modules/drills/views/DrillEdit.vue'),
    meta: {
      pageTitle: 'Drills',
      breadcrumbs: ['Drills']
    },
    props: true
  }
]

export default drillsRoutes
